import { shape, arrayOf, number } from 'prop-types';

import ProductPropType from 'Types/product';
import FiltersPropType from 'Types/filters';

const ProductsPropType = shape({
  products: arrayOf(ProductPropType),
  currentPage: number,
  recordsPerPage: number,
  totalPages: number,
  filters: FiltersPropType
});

export default ProductsPropType;
